import React from 'react';
import { StyledStatusContainer } from './styled.status';
import { Colors } from '../../../@types/genericTypes';
import { Headline6 } from './../../../common/typography';

type StatusTypes = 'Met' | 'Not Met' | 'N/A';

export interface StatusItem {
  value: string;
  color: Colors;
  status: StatusTypes;
}

export interface IStatus {
  items: StatusItem[];
}

export function Status ({ items }: IStatus) {
  return (
    <StyledStatusContainer>
      {items &&
        items.map((item, index) => (
          <Headline6 key={index} color={item.color}>
            {item.value} {item.status}
          </Headline6>
        ))}
    </StyledStatusContainer>
  );
}
